<template>
    <div>
        <!--头部公共部分-->
        <header data-am-widget="header" class="headers am-header am-header-pink">
            <div class="am-header-left am-header-nav">
                <a href="/" alt="华工激光">
                    <img src="https://res.baowugroup.com/wghglaser.com/public/themes/jiguang/public/mobile/images/logo.png" style="height:36px;margin-top:8px;" />
                </a>
            </div>
            <span style="position: absolute;right: 85px;top: 3px;width: 60px;">
                <a href="https://www.wghglaser.com/">中&nbsp;</a> <span style="float: none; margin-left: 0;">/</span>
                <a href="https://en.wghglaser.com/">&nbsp;EN</a>
            </span>
            <div class="search"><img src="https://res.baowugroup.com/wghglaser.com/public/themes/jiguang/public/mobile/images/style_01.png" /></div>
            <nav data-am-widget="menu" class="am-menu am-menu-offcanvas1" data-am-menu-offcanvas>
                <a href="javascript: void(0)" class="am-menu-toggle"></a>
                <div class="am-offcanvas">
                    <div class="am-offcanvas-bar">
                        <ul id="main-navigation" class="am-menu-nav sm-block-grid-1">
                            <li class=""> <a href="/" target="">首页</a> </li>
                            <li @click="addClass(index)" v-for="(item,index) in datas" :key="index" v-if="index<7" :class="['am-parent',isActive==index?'am-open':'']" >
                                <a href="javascript:;"  class="" data-toggle="dropdown"> {{item.nodeName}} <span class="caret"></span></a>
                                <ul :class="['am-menu-sub am-collapse am-avg-sm-1',isActive==index?'am-in':'']">
                                    <li class="" v-for="(citem,cindex) in item.l_list" :key='cindex' v-if="citem.nodeName!='pcbanner'">
                                        <a  href="javascript:;" target="" @click="linkUrl(item,citem)">{{citem.nodeName || citem.title}}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
        <!-- 搜索弹出框 -->
	    <div class="search-box"> 
	      <div class="container">
	        <input v-model="keyword" type="search" placeholder="搜索关键字" />
	        <div class="bt-close"><button @click="goSearch">搜索</button></div>
	      </div>
	    </div>
    </div>
</template>
<script>
import {
    API_GetMenuList,
    API_getNewsListAll
} from "@/fetch/api"
import $ from 'jquery'
export default {
    data () {
        return {
            isActive: null,
            datas: [],
            keyword: '',
        }
    },
    beforeMount () {
        this.actives = this.$route.params.nodeId
        // if (localStorage.getItem("storeState")) {
        //     let datas = JSON.parse(localStorage.getItem("storeState"));
        //     this.datas = datas.menuList;
        //     this.$store.commit("dataObj", datas);
        // } else {

        // }
        API_GetMenuList()
            .then(res => {
                let data = {
                    firstLevelMenuList: [],
                    firstLevelMenuListById: {},
                    secondLevelMenuListById: {},
                    menuList: []
                }
                let dataObj = res.data[0].childs
                dataObj.forEach(i => {
                    if (i.childs) {
                        i.r_list = []
                        i.l_list = i.childs
                        API_getNewsListAll({
                            pageNo: 0,
                            pageSize: 100,
                            condition: { nodeId: i.nodeId, isColor: 1 }
                        })
                            .then(res => {
                                let list = res.data.data
                                list.forEach(j => {
                                    if (j.nodeId == i.nodeId || j.node.parentId == i.nodeId) {
                                        i.r_list.push(j)
                                    }
                                })
                            })
                            .catch(err => {
                                console.log(err)
                            })
                    } else {
                        i.r_list = []
                        i.l_list = []
                        API_getNewsListAll({
                            pageNo: 0,
                            pageSize: 100,
                            condition: { nodeId: i.nodeId }
                            // condition: { nodeIds: [3687,3688],isColor:1}
                        })
                            .then(res => {
                                let list = res.data.data
                                list.forEach(j => {
                                    if (j.nodeId == i.nodeId && j.contentGroups[0]?.contentGroupName =='phone') {
                                        i.l_list.push(j)
                                        if (j.isColor == 1) {
                                            i.r_list.push(j)
                                        }

                                    }
                                })
                            })
                            .catch(err => {
                                console.log(err)
                            })
                    }
                })

                this.datas = dataObj
                data.menuList = dataObj
                this.$store.commit("dataObj", data)
            })
            .catch(error => {
                console.log(error)
            })

    },
    created () {
    },

    mounted () {
        $('.search img').click(function(){
            $('.search-box').stop().animate({top:0},200);
            $('.cover').css({'display':'block'});
            $('.cover').stop().animate({opacity:1},200);
        })
        $('.cover').click(function(){
            $('.search-box,.cover').stop().animate({top:-60},200);
            $('.cover').stop().animate({opacity:0},200);
            $('.cover').css({'display':'none'});
        })
    },
    methods: {
        goSearch () {
            if (this.keyword != '') {
                $('.search-box,.cover').stop().animate({top:-60},200);
                $('.cover').stop().animate({opacity:0},200);
                $('.cover').css({'display':'none'});
                this.$router.push(`/search?keyword=${this.keyword}`)
            }
        },
        linkUrl (item,citem) {
            $('.am-offcanvas').removeClass("am-active")
            $('.am-offcanvas-bar').removeClass("am-offcanvas-bar-active")
            $('body').removeClass("am-offcanvas-page") 
            let cnodeId = item.childs ? item.childs[0].nodeId : ''
            let params = { nodeId: item.nodeId, cnodeId: cnodeId }
            switch (item.nodeName) {
                case "产品中心":
                    this.$router.push({ name: 'product', params: { nodeId: item.nodeId, cnodeId: citem.nodeId } })
                    break
                case "加工中心":
                    this.$router.push({ name: 'processingDetails', params: { nodeId: item.nodeId,cnodeId:citem.nodeId}})
                    break
                case "工艺中心":
                    this.$router.push({ path: `/info/technology/${item.nodeId}?id=${citem.id}` })
                    break
                case "行业案例":
                    this.$router.push({ path: `/info/case/${item.nodeId}?id=${citem.id}` })
                    break
                case "服务支持":
                    if(citem.nodeName == '申请打样'){
                        window.open('https://affim.baidu.com/unique_68322204/mobile/chat?siteId=22060738&userId=68322204&siteToken=d0d7070de4be09160c67c026065c7b38')
                    }else{
                        this.$router.push({ name: 'service', params: { nodeId: item.nodeId,cnodeId:citem.nodeId}})
                    }
                    break
                case "新闻中心":
                    this.$router.push({ name: 'newsList',  params: { nodeId: item.nodeId,cnodeId:citem.nodeId}})
                    break
                case "关于我们":
                    this.$router.push({ name: 'aboutUs', params: { nodeId: item.nodeId,cnodeId:citem.nodeId}})
                    break
            }
        },
        childLinkUrl (item, citem) {
            switch (item.nodeName) {
                case "加工中心":
                    this.$router.push({ name: 'processingDetails', params: { nodeId: item.nodeId, cnodeId: citem.nodeId } })
                    break
                case "工艺中心":
                    this.$router.push({ path: `/info/technology/${item.nodeId}?id=${citem.id}` })
                    break
                case "行业案例":
                    this.$router.push({ path: `/info/case/${item.nodeId}?id=${citem.id}` })
                    break
                case "服务支持":
                    if (citem.id) {
                        this.$router.push({ path: `/article/service/${item.nodeId}/${citem.nodeId}?id=${citem.id}` })
                    } else {
                        this.$router.push({ path: `/service/${item.nodeId}/${citem.nodeId}`})
                    }
                    break
                case "新闻中心":
                    if (citem.id) {
                        if(citem.linkUrl ==''){
                            this.$router.push({ path: `/article/newsList/${item.nodeId}/${citem.nodeId}?id=${citem.id}`})
                        }else{
                            window.open(citem.linkUrl, '_blank');
                        }
                    } else {
                        this.$router.push({ path: `/newsList/${item.nodeId}/${citem.nodeId}` })
                    }
                    break
                case "关于我们":
                    this.$router.push({ name: 'aboutUs', params: { nodeId: item.nodeId, cnodeId: citem.nodeId } })
                    break
            }
        },
        productInfo (name, params) {
            this.$router.push({ name: name, params: params })
        },
        addClass(i) {
            if(i == this.isActive){
                this.isActive = null
            }else{
                this.isActive = i
            }
        },
    }
}
</script>
<style scoped>
.active {
    display: block
}
</style>